module.exports = __webpack_public_path__ + "static/media/Justin.891294ed.png";